"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _ossUpload = require("@/utils/ossUpload");
var _ActivitySelectionPopup = _interopRequireDefault(require("../../../appRenovation/component/components/ActivitySelectionPopup.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  props: [],
  data: function data() {
    return {
      activityJumpUrl: '',
      boole: false,
      num: '',
      moduleId: '',
      dialogVisible1: false,
      ruleForm: {
        title: '',
        selectUrl: '',
        normalUrl: '',
        isShow: '',
        jumpType: '',
        openUrl: '',
        activityType: '',
        activityId: '',
        activityTypeName: '',
        activityName: ''
      },
      nameObj: {
        0: 'home',
        1: 'local',
        2: 'rank',
        3: 'hair',
        4: 'mine'
      },
      options: [],
      rules: {
        title: [{
          required: true,
          message: '请输入导航名称',
          trigger: 'blur'
        }],
        selectUrl: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        normalUrl: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        isShow: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    goAct: function goAct() {
      this.$refs.activitySelectionPopup.open();
    },
    onSelectEvents: function onSelectEvents(data) {
      console.log(data);
      this.ruleForm.activityName = data.name || data.activityName || data.title;
      this.ruleForm.activityTypeName = data.Display_name;
      this.ruleForm.activityId = data.id || data.pageId;
      this.ruleForm.activityType = data.Display_type;
      this.activityJumpUrl = data.openUrl;
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, text) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              pictureUrl = '';
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file, 'builds', this.nameObj[this.num] + '_' + text + '.png');
            case 2:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              this.ruleForm[text] = "".concat(pictureUrl, "?").concat(new Date().getSeconds());
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    delPic: function delPic(val) {
      this.ruleForm[val] = '';
      console.log(this.ruleForm, '=======================');
    },
    open: function open(data) {
      var _this = this;
      console.log(data);
      if (data.num === 0 || data.isLast) {
        this.boole = true;
      } else {
        this.boole = false;
      }
      this.num = data.num;
      this.moduleId = data.moduleId;
      (0, _customPage.queryTabBarDetail)({
        moduleId: data.moduleId
      }).then(function (res) {
        if (res.data && res.data != null) {
          _this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
            title: res.data.name,
            selectUrl: res.data.selectedPic,
            normalUrl: res.data.unSelectedPic,
            isShow: res.data.status
          });
          if (res.data.jumpType === 2) {
            _this.activityJumpUrl = res.data.openUrl;
            _this.ruleForm.openUrl = '';
          }
        }
      });
      this.dialogVisible1 = true;
    },
    onClose: function onClose() {
      var _this2 = this;
      this.ruleForm.activityType = '';
      this.ruleForm.activityId = '';
      this.ruleForm.activityTypeName = '';
      this.ruleForm.activityName = '';
      this.ruleForm.openUrl = '';
      this.$nextTick(function () {
        _this2.$refs['ruleForm'].resetFields();
      });
      this.dialogVisible1 = false;
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this3.ruleForm);
          (0, _customPage.updateTabBar)({
            moduleId: _this3.moduleId,
            name: _this3.ruleForm.title,
            unSelectedPic: _this3.ruleForm.normalUrl,
            selectedPic: _this3.ruleForm.selectUrl,
            status: _this3.ruleForm.isShow,
            jumpType: _this3.ruleForm.jumpType,
            activityId: _this3.ruleForm.activityId,
            activityName: _this3.ruleForm.jumpType === 1 ? '' : _this3.ruleForm.activityName,
            activityType: _this3.ruleForm.activityType,
            openUrl: _this3.ruleForm.jumpType === 2 ? _this3.activityJumpUrl : _this3.ruleForm.openUrl
          }).then(function (res) {
            if (res.data) {
              _this3.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this3.$emit('refresh');
              _this3.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.ruleForm.activityType = '';
      this.ruleForm.activityId = '';
      this.ruleForm.activityTypeName = '';
      this.ruleForm.activityName = '';
      this.ruleForm.openUrl = '';
      if (this.boole) {
        this.ruleForm.selectUrl = '';
        this.ruleForm.normalUrl = '';
        this.$refs['ruleForm'].clearValidate(['selectUrl', 'normalUrl']);
      } else {
        this.$refs[formName].resetFields();
      }
    }
  }
};